export default class OverlayController
  @show = (content, { title } = { }) ->
    App.state.setObject overlay: { content, title }

  @hide = ->
    App.state.deleteObject 'overlay'

# App.controllers.OverlayController.show("the content", "The Header")
